import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import PanelContent from '@portal/components/PanelContent/PanelContent';

import { getRouteStackPath } from '@portal/config/routes';
import { translate } from '@portal/services/i18n';

import { PageClass } from '@portal/enum/analytics';
import { sendEvent } from '@portal/services/firebase';
import RechargeSelection from './RechargeSelection/RechargeSelection';
import RechargeHistory from './RechargeHistory/RechargeHistory';

const RechargeNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.RECHARGE,
    });
  }, [location]);

  return (
    <Switch>
      <Route
        exact
        path={getRouteStackPath('RECHARGE', 'RECHARGE_SELECTION_PAGE')}
      >
        <PanelContent pageTitle={translate('PAGES.RECHARGE.SELECTION.TITLE')}>
          <RechargeSelection />
        </PanelContent>
      </Route>
      <Route
        exact
        path={getRouteStackPath('RECHARGE', 'RECHARGE_HISTORY_PAGE')}
      >
        <PanelContent
          pageTitle={translate('PAGES.RECHARGE.MODE.HISTORY.TITLE')}
        >
          <RechargeHistory />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default RechargeNavigationStack;
